import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

// Configure request setup
const serviceName = 'VideosService'
const host = servicesConfig.Videos
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const VideosService = {
  getGIF: async (url: string, locationId: string) =>
    request().get(`/gif?locationId=${locationId}&url=${url}`).then(responseBody)
}

export default VideosService
